import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  readonly SYNC_SESSION_KEY = 'requestSyncSessionStorage';
  readonly SESSION_STORAGE_KEY = 'sessionStorage';

  constructor() {
    window.addEventListener('storage', this.handleStorageEvent, false);
    this.requestSyncSessionStorage();
  }

  handleStorageEvent = (event: StorageEvent): void => {
    if (event.key === this.SYNC_SESSION_KEY) {
      localStorage.setItem(
        this.SESSION_STORAGE_KEY,
        JSON.stringify(sessionStorage)
      );
      localStorage.removeItem(this.SESSION_STORAGE_KEY);
    } else if (event.key === this.SESSION_STORAGE_KEY) {
      const sessionStorage = JSON.parse(event.newValue || '{}');
      for (const key in sessionStorage) {
        window.sessionStorage.setItem(key, sessionStorage[key]);
      }
    }
  };

  requestSyncSessionStorage(): void {
    if (!sessionStorage.length) {
      const current = new Date().toLocaleTimeString();
      localStorage.setItem(
        this.SYNC_SESSION_KEY,
        'request session storage' + current
      );
    }
  }

  getUserdetails(): any {
    return JSON.parse(sessionStorage.getItem('userDetails'));
  }

  setUserdetails(userDetails: any) {
    sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
  }
  getRoleUserdetails(): any {
    return JSON.parse(sessionStorage.getItem('roleUserDetails'));
  }
  setRoleUserDetails(roleUserDetails: any) {
    sessionStorage.setItem('roleUserDetails', JSON.stringify(roleUserDetails));
  }

  destroyRoleUserDetails() {
    sessionStorage.removeItem('roleUserDetails');
  }
  destroyUserdetails() {
    sessionStorage.removeItem('userDetails');
  }
  getWebToken(): any {
    return JSON.parse(sessionStorage.getItem('webToken'));
  }
  setWebToken(roleUserDetails: any) {
    sessionStorage.setItem('webToken', JSON.stringify(roleUserDetails));
  }

  destroyWebToken() {
    sessionStorage.removeItem('webToken');
  }
}
